import {
  LIBRARY_BRANDS_PAGE_REQUEST,
  LIBRARY_BRANDS_LIST_REQUEST,
  LIBRARY_BRANDS_SET_LIST_BRAND,
  LIBRARY_BRANDS_ON_CHANGE_OUTLET_IDS,
  LIBRARY_BRANDS_SET_OUTLETS,
  LIBRARY_BRANDS_SET_CURRENT_PAGE,
  LIBRARY_BRANDS_SET_TOTAL_PAGE,
  LIBRARY_BRANDS_SET_KEYWORD,
  LIBRARY_BRANDS_ON_CLICK_ROW,
  LIBRARY_BRANDS_SET_BRAND_DETAIL,
  LIBRARY_BRANDS_ON_CLICK_CANCEL,
  LIBRARY_BRANDS_ON_CLICK_CREATE_BRAND,
  LIBRARY_BRANDS_SUBMIT_FORM_UPDATE,
  LIBRARY_BRANDS_SUBMIT_FORM_CREATE,
  LIBRARY_BRANDS_SUBMIT_FORM_CREATE_ALL_OUTLETS,
  LIBRARY_BRANDS_DELETE_BRAND_REQUEST,
  LIBRARY_BRANDS_SHOW_DELETE_MODAL,
  LIBRARY_BRANDS_HIDE_DELETE_MODAL,
  LIBRARY_BRANDS_SHOW_UPDATE_MODAL,
  LIBRARY_BRANDS_HIDE_UPDATE_MODAL,
  LIBRARY_BRANDS_CANCEL_DELETE,
  LIBRARY_BRANDS_DELETE_BRAND,
  LIBRARY_BRANDS_SET_DELETED_BRAND,
  LIBRARY_BRANDS_OPEN_RIGHT_COLUMN,
  LIBRARY_BRANDS_CLOSE_RIGHT_COLUMN,
  LIBRARY_BRANDS_IS_SUBMITTING_FORM,
} from './constants';

export function brandsPageRequest() {
  return { type: LIBRARY_BRANDS_PAGE_REQUEST, payload: {} };
}

export function brandsRequest(params, previousBrands?) {
  return {
    type: LIBRARY_BRANDS_LIST_REQUEST,
    payload: { params, previousBrands },
  };
}

export function setListBrands(brands) {
  return {
    type: LIBRARY_BRANDS_SET_LIST_BRAND,
    payload: { brands },
  };
}

export function onChangeOutletIds(outletIds) {
  return {
    type: LIBRARY_BRANDS_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds },
  };
}

export function setOutlets(outlets) {
  return { type: LIBRARY_BRANDS_SET_OUTLETS, payload: { outlets } };
}

export function setCurrentPage(currentPage) {
  return {
    type: LIBRARY_BRANDS_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPage(totalPage) {
  return { type: LIBRARY_BRANDS_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function setKeyword(keyword) {
  return { type: LIBRARY_BRANDS_SET_KEYWORD, payload: { keyword } };
}

export function onClickRow(brand) {
  return { type: LIBRARY_BRANDS_ON_CLICK_ROW, payload: { brand } };
}

export function setBrandDetail(brand) {
  return {
    type: LIBRARY_BRANDS_SET_BRAND_DETAIL,
    payload: { brand },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_BRANDS_ON_CLICK_CANCEL, payload: {} };
}

export function onClickCreateBrand() {
  return { type: LIBRARY_BRANDS_ON_CLICK_CREATE_BRAND, payload: {} };
}

export function submitFormUpdate(id, data, previousBrands) {
  return {
    type: LIBRARY_BRANDS_SUBMIT_FORM_UPDATE,
    payload: { id, data, previousBrands },
  };
}

export function submitFormCreate(data, previousBrands) {
  return {
    type: LIBRARY_BRANDS_SUBMIT_FORM_CREATE,
    payload: { data, previousBrands },
  };
}

export function submitFormCreateAllOutlets(data, previousBrands) {
  return {
    type: LIBRARY_BRANDS_SUBMIT_FORM_CREATE_ALL_OUTLETS,
    payload: { data, previousBrands },
  };
}

export function setDeletedBrand(deletedBrand) {
  return {
    type: LIBRARY_BRANDS_SET_DELETED_BRAND,
    payload: { deletedBrand },
  };
}

export function deleteBrandRequest(deletedBrand) {
  return {
    type: LIBRARY_BRANDS_DELETE_BRAND_REQUEST,
    payload: { deletedBrand },
  };
}

export function showDeleteModal() {
  return { type: LIBRARY_BRANDS_SHOW_DELETE_MODAL, payload: {} };
}

export function hideDeleteModal() {
  return { type: LIBRARY_BRANDS_HIDE_DELETE_MODAL, payload: {} };
}

export function showUpdateModal() {
  return { type: LIBRARY_BRANDS_SHOW_UPDATE_MODAL, payload: {} };
}

export function hideUpdateModal() {
  return { type: LIBRARY_BRANDS_HIDE_UPDATE_MODAL, payload: {} };
}

export function cancelDelete() {
  return { type: LIBRARY_BRANDS_CANCEL_DELETE, payload: {} };
}

export function deleteBrand(id, previousBrands) {
  return {
    type: LIBRARY_BRANDS_DELETE_BRAND,
    payload: { id, previousBrands },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_BRANDS_OPEN_RIGHT_COLUMN, payload: {} };
}

export function closeRightColumn() {
  return { type: LIBRARY_BRANDS_CLOSE_RIGHT_COLUMN, payload: {} };
}

export function isSubmittingForm(isSubmittingFormPayload) {
  return {
    type: LIBRARY_BRANDS_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm: isSubmittingFormPayload },
  };
}
